import React from "react";

import { moneyFormat } from "./format";
import TwoPanels from "./TwoPanels";
import Text from "./Text";
import { IncomeStatementPanel } from "./IncomeStatement";

const OAFinancialImpact = ({ incomeStatement }) => {
  return (
    <TwoPanels
      title1="Financial Impact of Operation's Decisions"
      title2="IncomeStatement"
    >
      <fragment>
        <Text>
          As a result of your operation decisions, your team incurred the
          following costs:
        </Text>
        <Text>
          <b>Cost of Sales</b>: Your Cost of Sales of{" "}
          {moneyFormat(-incomeStatement["Cost of Sales"])} was partly driven by
          the product feature quality. The higher the quality, the more
          expensive the materials that is needed to produce the product.
        </Text>
        {incomeStatement["Holding Costs"] !== 0 && (
          <Text>
            <b>Holding Costs</b>: Your holding costs of{" "}
            {moneyFormat(-incomeStatement["Holding Costs"])} is the costs of
            holding unsold inventory.
          </Text>
        )}
        {incomeStatement["Gain or Loss of Sales"] !== 0 && (
          <Text>
            <b>Loss on Sale</b>: This non-operating costs is a result of selling
            your production lines (i.e. machines).
          </Text>
        )}
      </fragment>
      <IncomeStatementPanel sheet={incomeStatement} />
    </TwoPanels>
  );
};

export default OAFinancialImpact;



// WEBPACK FOOTER //
// ./src/components/analysis/OAFinancialImpact.js